import { render, staticRenderFns } from "./ErrorNotifications.vue?vue&type=template&id=3cfe6f4c&scoped=true&"
import script from "./ErrorNotifications.vue?vue&type=script&lang=js&"
export * from "./ErrorNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfe6f4c",
  null
  
)

export default component.exports